import {Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FmcElementsComponent} from '../fmc-elements.component';
import {FormsModule, ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {CarModel} from './car.model';
import {debounceTime} from 'rxjs/operators';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {NgFor} from '@angular/common';

@Component({
  selector: 'fmc-car-search',
  templateUrl: './car-search.component.html',
  styleUrls: ['./car-search.component.css'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    NgFor
  ]
})
export class CarSearchComponent extends FmcElementsComponent implements OnInit, OnChanges {
  public defaultControl = new CarModel().carForm;
  public defaultControlType = 'FormGroup';
  public filteredCars: any;
  public errorMessage: '';
  // public collateralClass: '';
  public currentSearch = '';
  public formGroup: UntypedFormGroup;
  @Input() public panelWidth; //panel width parameter for autoComplete
  @Input() public vehicleType: string;
  @Input() public collateralClass: string;
  @Output() public carSelected = new EventEmitter();

  ngOnInit() {
    super.ngOnInit();
    this.doSearch(this.formGroup.value.text);
    this.formGroup.get('text').valueChanges.pipe(debounceTime(500)).subscribe((val) => {
      // only search if theres a value -- or if value changed
      this.doSearch(val);
    });

    if (this.disable) {
      this.formGroup.get('text').disable();
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.formGroup && this.formGroup.get('text') && changes && changes.vehicleType) {
      if (changes.vehicleType.currentValue) {
        if (changes.vehicleType.previousValue && changes.vehicleType.previousValue !== changes.vehicleType.currentValue) {
          this.filteredCars = [];
        }
        this.collateralClass = changes.vehicleType.currentValue;
        this.formGroup.get('text').enable();
      } else {
        console.log('asset search disabled', changes, this.formGroup);
        this.formGroup.get('text').disable();
      }
    }
  }

  doSearch(val) {
    if (!val || this.currentSearch === val) return;
    this.currentSearch = val;
    this.formGroup.get('text').setErrors({invalid: true});
    this.collateralService.searchMotorVehicles(val, 100, this.collateralClass)
      .subscribe(result => {
        // console.log(result);
        this.filteredCars = result
        .filter(res => {
          // make sure to only show results with the exact string
          return res.description.toLowerCase().indexOf(val.toLowerCase()) !== -1;
        })
        .sort(function (a, b) {
          return a.description.localeCompare(b.description);
        });

        if (this.filteredCars.length === 1) { // only drill down if car search is not a year
          this.updatedSelectedVehicleRecord(this.filteredCars[0]);
        } else {
          const record = this.filteredCars.find(t => t.description === this.currentSearch);
          this.updatedSelectedVehicleRecord(record);
        }
      });
  }

  updatedSelectedVehicleRecord(record) {
    console.log('updatedSelectedVehicleRecord', record);
    if (record && !record.description){
      record = this.filteredCars.find(t => t.description === record);
    }

    if (!record) {
      this.formGroup.get('text').setErrors({invalid: true});
      return
    };

    // do not trigger the search again
    // this.formGroup.get('text').patchValue(record.description);
    this.currentSearch = record.description;
    this.formGroup.get('text').setErrors(null, {emitEvent: false});
    this.formGroup.get('text').updateValueAndValidity({emitEvent: false});
    this.formGroup.get('id').patchValue(record.slug);
    this.formGroup.get('description').patchValue(record.description);
    this.formGroup.get('make').patchValue(record.make.name);
    this.formGroup.get('model').patchValue(record.model.name);
    this.formGroup.get('makeSlug').patchValue(record.make.slug);
    this.formGroup.get('modelSlug').patchValue(record.model.slug);
    this.formGroup.get('class').patchValue(record.class);
    // this.formGroup.get('green').patchValue(record.green);
    this.formGroup.get('year').patchValue(record.year);
    this.carSelected.emit(this.formGroup.value);
  }
}
